// Shared helpers for the per-day calling schedule
export const DAYS = [
  { id: 0, label: "Monday", short: "Mon" },
  { id: 1, label: "Tuesday", short: "Tue" },
  { id: 2, label: "Wednesday", short: "Wed" },
  { id: 3, label: "Thursday", short: "Thu" },
  { id: 4, label: "Friday", short: "Fri" },
  { id: 5, label: "Saturday", short: "Sat" },
  { id: 6, label: "Sunday", short: "Sun" },
];

export const defaultSchedule = () =>
  DAYS.reduce((acc, d) => {
    acc[String(d.id)] = {
      enabled: d.id < 5,
      start_hour: 9,
      end_hour: 17,
    };
    return acc;
  }, {});

const pad = (h) => String(h).padStart(2, "0");

export const fmtHour = (h) => `${pad(h)}:00`;

export const scheduleSummary = (schedule) => {
  if (!schedule) return "Mon–Fri 09:00–17:00";
  const parts = [];
  let i = 0;
  while (i < 7) {
    const cfg = schedule[String(i)];
    if (!cfg || !cfg.enabled) {
      i++;
      continue;
    }
    let j = i;
    while (
      j + 1 < 7 &&
      schedule[String(j + 1)]?.enabled &&
      schedule[String(j + 1)]?.start_hour === cfg.start_hour &&
      schedule[String(j + 1)]?.end_hour === cfg.end_hour
    ) {
      j++;
    }
    const label =
      i === j
        ? DAYS[i].short
        : `${DAYS[i].short}–${DAYS[j].short}`;
    parts.push(`${label} ${fmtHour(cfg.start_hour)}–${fmtHour(cfg.end_hour)}`);
    i = j + 1;
  }
  return parts.length ? parts.join(" · ") : "No days enabled";
};
